import React from 'react';
import { useQuery } from '@tanstack/react-query';
import Pagination from './pagination';

  const apiUrl = process.env.REACT_APP_API_URL;

const fetchNews = async (page = 1, perPage = 8) => {
  const response = await fetch(`${apiUrl}/api/news?page=${page}&per_page=${perPage}`);
  
  if (!response.ok) {
    throw new Error('Network response was not ok');
  }
  
  return response.json();
};

const NewsList = () => {
  const [currentPage, setCurrentPage] = React.useState(1);
  const perPage = 8; 

  const {
    data,
    isLoading,
    isError,
    error,
    isFetching
  } = useQuery({
    queryKey: ['news', currentPage, perPage],
    queryFn: () => fetchNews(currentPage, perPage),
    keepPreviousData: true, 
    staleTime: 5 * 60 * 1000, 
  });

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };


  if (isLoading) {
    return (
      <div className="card">
        <div className="card-header">
          <h3>آخر الأخبار</h3>
        </div>
        <div className="card-body">
          <div className="news-list-dash">
            <div className="text-center py-4">
              <div className="spinner-border" role="status">
                <span className="sr-only">Loading...</span>
              </div>
              <p>جاري تحميل الأخبار...</p>
            </div>
          </div>
        </div>
      </div>
    );
  }


  if (isError) {
    return (
      <div className="card">
        <div className="card-header">
          <h3>آخر الأخبار</h3>
        </div>
        <div className="card-body">
          <div className="alert alert-danger">
            <h4>خطأ في تحميل الأخبار</h4>
            <p>{error.message}</p>
            <button 
              className="btn btn-primary"
              onClick={() => window.location.reload()}
            >
              إعادة المحاولة
            </button>
          </div>
        </div>
      </div>
    );
  }

  const newsData = data?.data || [];
  const pagination = data?.pagination || {};

  return (
    <div className="card">
      <div className="card-header">
        <h3>آخر الأخبار</h3>
        {isFetching && (
          <small className="text-muted">جاري التحديث...</small>
        )}
      </div>
      <div className="card-body">
        <div className="news-list-dash">
          {newsData.length === 0 ? (
            <div className="text-center py-4">
              <p>لا توجد أخبار متاحة حالياً</p>
            </div>
          ) : (
            newsData.map((news, index) => (
              <div key={news.id || index} className="news-item-dash">
                <div className="news-content-dash">
                 <h4 title={news.title}>
                  {news.title?.length > 100 
                    ? `${news.title.substring(0, 100).trim()}...` 
                    : news.title || 'بدون عنوان'
                  }
                </h4>
                  <p className="news-date-dash">
                    {news.published_at 
                      ? new Date(news.published_at).toLocaleDateString('ar-EG')
                      : new Date(news.created_at).toLocaleDateString('ar-EG')
                    }
                  </p>
                </div>
                <button 
                  className="view-btn-dash"
            
                >
                  عرض
                </button>
              </div>
            ))
          )}
        </div>
        
        {pagination.last_page > 1 && (
          <Pagination 
            currentPage={pagination.current_page}
            totalPages={pagination.last_page}
            onPageChange={handlePageChange}
          />
        )}
      </div>
    </div>
  );
};

export default NewsList;